import getLogger from '~/shared/logger'

export const getProductsWithGallery = async (locale: string): Promise<Array<string> | null> => {
  try {
    const response = await fetch(`https://components-config.prod.product-collections.vpsvc.com/vistaprint/products/${locale}.json`)

    if (!response.ok) {
      throw new Error(
        JSON.stringify({
          status: response.status,
          message: 'Failed to fetch Gallery Products',
        }),
      )
    }

    return await response.json()
  } catch (err: unknown) {
    getLogger().error(err)
    return null
  }
}

export const arrangeProductsInOrderWithProductList = (
  products: ProductVariations.ProductVariationResponse[],
  productList: string[],
): ProductVariations.ProductVariationResponse[] => {
  const productMap = new Map(products.map((product: ProductVariations.ProductVariationResponse) => [product.productKey, product]))

  return productList
    .filter((key) => productMap.has(key))
    .map((key) => productMap.get(key))
    .filter((product): product is ProductVariations.ProductVariationResponse => Boolean(product))
}
